import type { MapRef, LngLatBoundsLike } from 'react-map-gl';
import { AllTrailsResult } from '../types/Results';
import fitBoundsOnLoad from './fitBoundsOnLoad';
import { defaultPadding } from './constants';

const fitBoundsParams = {
  padding: defaultPadding,
  maxZoom: 12,
  duration: 0
};

type Props = {
  map?: MapRef;
  results?: AllTrailsResult[];
  bounds?: LngLatBoundsLike;
};

const fitBoundsOfArea = ({ map, results, bounds }: Props) => {
  if (!map) {
    return;
  }

  if (!!bounds) {
    map.fitBounds(bounds, fitBoundsParams);
  }

  if (!!results) {
    fitBoundsOnLoad(results, map, 0, defaultPadding, 12);
  }
};

export default fitBoundsOfArea;
